import React from "react";
import "./ImpersonationBanner.css";
import * as auth from "../../backend/auth";
import { navigate } from "raviger";
import { getBasePath } from "../../App";
import { preventDefault } from "../../utils/common";

// Persistent "you are inside someone else's account" pill for the master-password
// impersonation flow, shown inline in the header. Not dismissible except via
// "End session" — see hotfix spec.
function ImpersonationBanner() {
    const impersonating = auth.isImpersonating();

    const { endImpersonation, isLoading } = auth.useEndImpersonation(finish, finish);

    function finish() {
        // End it client-side regardless of whether the API call succeeded, so the admin
        // is never stuck — same clear+redirect+reload pattern as a normal logout. There's no
        // separate admin session to return to (the impersonated user's token IS the session),
        // so this is a real logout — land on /login explicitly, not '/'.
        auth.clearUserSession();
        navigate(`${getBasePath()}/login`, { replace: true });
        window.location.reload();
    }

    function handleEndSession(event: any) {
        preventDefault(event);
        endImpersonation();
    }

    if (!impersonating) {
        return null;
    }

    const user = auth.getUserDetails() || {};
    const impersonatedBy = auth.getImpersonatedBy();

    return (
        <div className="impersonation-banner">
            <span>
                Viewing as {user.name} — impersonated by {impersonatedBy.name}
            </span>
            <a href="/" onClick={handleEndSession} className="impersonation-banner-end">
                {isLoading ? 'Ending session…' : 'End session'}
            </a>
        </div>
    );
}

export default ImpersonationBanner;
